// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.point-highlighted [class*="point-shape"] {
  stroke: white !important;
  stroke-width: calc(6px / var(--vis-map-current-zoom-level, 1)) !important;
  opacity: 1 !important;
}`, "",{"version":3,"sources":["webpack://./src/examples/maps/topojson/clustered-color-map/style.module.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,yEAAyE;EACzE,qBAAqB;AACvB","sourcesContent":[":global(.point-highlighted) [class*=\"point-shape\"] {\n  stroke: white !important;\n  stroke-width: calc(6px / var(--vis-map-current-zoom-level, 1)) !important;\n  opacity: 1 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
